/**
 * 予人智图 / picforge 设计 tokens。
 * apps/admin, apps/creator 通过 AntD ConfigProvider 消费；
 * apps/mini-program 通过 taro scss 变量二次桥接（详见 mini-program 构建配置）。
 */

export const BRAND_NAME_ZH = '予人智图';
export const BRAND_NAME_EN = 'picforge';
export const BRAND_TAGLINE_ZH = '让每一张图都被精心对待';

export const COLORS = {
  /** 主色：温暖的胡桃棕，呼应"智造图集"的手工感，避免科技冷感 */
  primary: '#B45309',
  /** 辅助主色：柔和的米白 */
  primarySoft: '#FEF3C7',
  /** 链接色，沿用 AntD 经典蓝调微调 */
  link: '#1D4ED8',
  success: '#15803D',
  warning: '#F59E0B',
  danger: '#DC2626',
  /** 中性色，偏暖 */
  text: '#1F2937',
  textSecondary: '#6B7280',
  textTertiary: '#9CA3AF',
  border: '#E5E7EB',
  background: '#FAFAF9',
  backgroundSoft: '#F5F5F4',
  white: '#FFFFFF',
} as const;

export const RADIUS = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
} as const;

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const TYPOGRAPHY = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Segoe UI", Roboto, sans-serif',
  fontSizeBase: 14,
  fontSizeSm: 12,
  fontSizeLg: 16,
  fontSizeXl: 20,
  fontSizeHeading: 28,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  lineHeightBase: 1.6,
} as const;

/** AntD v5 ConfigProvider theme token 建议值。用于 admin / creator。 */
export const ANTD_THEME_TOKEN = {
  colorPrimary: COLORS.primary,
  colorLink: COLORS.link,
  colorSuccess: COLORS.success,
  colorWarning: COLORS.warning,
  colorError: COLORS.danger,
  colorTextBase: COLORS.text,
  colorBgLayout: COLORS.background,
  colorBorder: COLORS.border,
  borderRadius: RADIUS.md,
  fontFamily: TYPOGRAPHY.fontFamily,
  fontSize: TYPOGRAPHY.fontSizeBase,
} as const;
